import { Head, useForm, usePage } from "@inertiajs/react";
import AuthShell from "@/components/auth/AuthShell";
import ChildMatchCard from "@/components/parents/ChildMatchCard";

/**
 * After a parent opens their activation email: they're signed in, and
 * confirm the code matched their child before it's linked.
 */
export default function PendingClaim({ student, confirm_path, cancel_path, requires_privacy_consent = false }) {
  const { routes } = usePage().props;
  const form = useForm({ privacy_consent: false });
  const submit = (e) => {
    e.preventDefault();
    form.post(confirm_path);
  };

  return (
    <AuthShell helpHref={routes.help_parents}>
      <Head title="Is this your child? · PagePledge" />
      <div className="space-y-6">
        <div className="space-y-2 text-center">
          <h1 className="font-display text-3xl font-semibold text-foreground">Is this your child?</h1>
          <p className="text-muted-foreground">You're signed in. Confirm and we'll add them to your account.</p>
        </div>
        <ChildMatchCard
          student={student}
          form={form}
          onSubmit={submit}
          cancelHref={cancel_path}
          requireConsent={requires_privacy_consent}
          consentId="pending_parent_privacy_consent"
        />
      </div>
    </AuthShell>
  );
}
